import {gql} from "@apollo/client";

import {ChecksListColumnDef, ChecksListView} from "@/lib/types/checksListViews.ts";
import {GenericMutationResponse, GraphQLResponse} from "@/lib/types/common.ts";

export interface ChecksListViewsData {
  checksListViews: {
    total: number;
    items: ChecksListView[];
  };
}

export interface ChecksListAvailableColumnsData {
  checksListAvailableColumns: ChecksListColumnDef[];
}

export type SaveChecksListViewResult = GraphQLResponse<ChecksListView>;

export type DeleteChecksListViewResult = GenericMutationResponse;

export const GQL_CHECKS_LIST_VIEWS = gql`
  query ChecksListViews {
    checksListViews {
      total
      items {
        id
        name
        columns
        default_sort
        default_sort_direction
        is_default
        created_by_name
      }
    }
  }
`;

export const GQL_CHECKS_LIST_AVAILABLE_COLUMNS = gql`
  query ChecksListAvailableColumns {
    checksListAvailableColumns {
      id
      label
      sortable
      sort_field
      category
    }
  }
`;

export const GQL_CHECKS_LIST_VIEW_SAVE = gql`
  mutation ChecksListViewSave($id: Int, $data: ChecksListViewInput!) {
    response: checksListViewSave(id: $id, data: $data) {
      ... on SaveChecksListViewSuccess {
        status
        data {
          id
          name
          columns
          default_sort
          default_sort_direction
          is_default
          created_by_name
        }
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_CHECKS_LIST_VIEW_DELETE = gql`
  mutation ChecksListViewDelete($id: Int!) {
    response: checksListViewDelete(id: $id) {
      ... on GenericMutationResponseSuccess {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_CHECKS_LIST_VIEW_SET_DEFAULT = gql`
  mutation ChecksListViewSetDefault($id: Int!) {
    response: checksListViewSetDefault(id: $id) {
      ... on GenericMutationResponseSuccess {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;
